<div style='width:80%;padding:100px'>
    <h3>Terms and conditions:</h3><br />

    By joining Golf GamesKeeper you agree to pay the current published membership fees on the web site.
    You also agree to auto renew your membership every month or 365 days based on the membership selected at the same
    rate to gain access
    to all the benefits associated with your subscription.<br /><br />
    Access to your paid online membership and all benefits associated with your selected Subscription Plan will be
    granted upon checkout.<br /><br />
    You also agree that it is your responsibility as a golfer to make sure your events are ran using the correct
    scoring, if you identify an
    error in one of our scorecard please notify us and we will do our best to correct it prior to your event.
    Golf GamesKeeper will send out periodic e-mails regarding your membership, benefits, and other related content.
    <br /><br />
    Further, we may, without notice to you, suspend or cancel your subscription at any time even without receiving
    notice from you if we suspect, in our sole discretion, that your account with us or your email account is being used
    in an unauthorized manner. <br /><br />

    Golf GamesKeeper, LLC, 4400 Scottsdale RD STE 9-747 Scottsdale, AZ 85251.<br />Contact Customer Service:
    info&#64;golfgameskeeper.com.<br /><br />
</div>